import { FaHome } from "react-icons/fa";
import { SortOption } from "../../../components/SortAndFilterSection";

export const sortOptions: SortOption[] = [
  {
    label: "Navn",
    id: "name",
  },
  {
    label: "Maksimum",
    id: "maximum",
  },
  {
    label: "Oppdatert",
    id: "updated",
  },
];

export const selectableFilterOptions = [
  {
    id: "status",
    label: "Status",
    icon: <FaHome />,
    options: [
      { id: "active", label: "Aktiv" },
      { id: "inactive", label: "Inaktiv" },
    ],
  },
];
